import React, { useCallback, useState } from "react";
import clsx from "clsx";
import { ChatGpcUi } from "./ChatGpcUi";
import { AskGpcUi } from "./AskGpcUi";
import { AppType } from "../../../types";

import "./ChatUiStyles.css";

export const ChatUi = () => {
  const [activeApp, setActiveApp] = useState<AppType>(AppType.chatGpc);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const toggleSidebar = useCallback(() => setSidebarExpanded((prev) => !prev), []);

  return (
    <div className="theme-container">
      <div className={clsx("chat-screen-container", sidebarExpanded && "sidebar-expanded")}>
        {activeApp === AppType.chatGpc ? (
          <ChatGpcUi activeApp={activeApp} setActiveApp={setActiveApp} toggleSidebar={toggleSidebar} />
        ) : (
          <AskGpcUi activeApp={activeApp} setActiveApp={setActiveApp} toggleSidebar={toggleSidebar} />
        )}
      </div>
    </div>
  );
};
